import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { EnvironmentService } from '@pinnakl/core/environment';
import { CrmWorkspacesStore } from '@pinnakl/crm/data-access';
import { PinnaklIconComponent } from '@pinnakl/shared/ui/icons';

import { PopoverRightDirective, PrimeButtonComponent } from '@pinnakl/shared/ui/prime';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'header-user-profile',
  templateUrl: './header-user-profile.component.html',
  imports: [PinnaklIconComponent, Popover, PopoverRightDirective, PrimeButtonComponent, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderUserProfileComponent {
  private readonly environmentService = inject(EnvironmentService);
  private readonly crmWorkspacesStore = inject(CrmWorkspacesStore);
  protected readonly workspaces = this.crmWorkspacesStore.workspaces;
  protected readonly selectedWorkspaceId = this.crmWorkspacesStore.selectedWorkspaceId;
  protected readonly version = this.environmentService.version;
  userName = input.required<string>();
  logout = output();

  selectWorkspace(idToSelect: number): void {
    if (idToSelect === this.selectedWorkspaceId()) {
      return;
    }
    this.crmWorkspacesStore.selectWorkspace(idToSelect);
    // Land on the dashboard via a full reload: root stores cache workspace-scoped data,
    // and the current page may not exist in the new workspace
    window.location.assign('/dashboard');
  }
}
